import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { PodstronaComponent } from './podstrona/podstrona.component';
import { StronaComponent } from './strona/strona.component';
import { RedirectComponent } from './redirect/redirect.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { ResetComponent } from './reset/reset.component';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

@NgModule({
  declarations: [
    AppComponent,
    PodstronaComponent,
    StronaComponent,
    RedirectComponent,
    ConfirmComponent,
    ResetComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule
    //RouterModule.forRoot(routes,{ preloadingStrategy: PreloadAllModules })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
